module.exports = __webpack_public_path__ + "static/media/6_paporotnik_92.5_47.96.aecb2f7a.png";